import React, { Fragment } from "react";
import FrontAbstract from "./../assets/journals/frontabstract.jpg";
import FrontField from "./../assets/journals/frontfield.jpg";
import CartCard from "./CartCard";
import { useParams } from "react-router-dom";

const CartLanding = () => {
  const { id } = useParams();

  return (
    <Fragment>
      <div className="flex justify-between flex-col md:flex-row items-center mt-16">
        <div className="w-full md:w-2/5">
          <div className="flex gap-4">
            <img
              src={FrontAbstract}
              alt="Abstract design journal"
              className="w-[16rem] rounded-md hidden md:block"
            />
            <img
              src={FrontField}
              alt="Field design journal"
              className="md:w-[16rem] rounded-md w-fit"
            />
          </div>
        </div>
        <div className="md:w-[50%] w-full mt-12 md:mt-0">
          {id === "abstract-design" && (
            <CartCard
              productImg={FrontAbstract}
              productName="The 360 Believer Journal - Abstract Design"
            />
          )}
          {id === "field-design" && (
            <CartCard
              productImg={FrontField}
              productName="The 360 Believer Journal - Field Design"
            />
          )}
        </div>
      </div>
    </Fragment>
  );
};

export default CartLanding;
